import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { MonitoringResponse } from "../types/Monitoring";


const fetchProfileMonitoring = async (
  authHeader: string,
  profileId: number
) => {
  const url = new URL(`${env.verifyServiceUrl}individual/monitoring/`);

  url.searchParams.set("profile", String(profileId));

  const res = await axios.get<MonitoringResponse>(url.href, {
    headers: { Authorization: authHeader },
  });

  return (res.data as any)?.data ?? res.data;
};

export const useProfileMonitoring = (profileId?: number) => {
  const { authHeader, hasPermission } = useAuth();
  const navigate = useNavigate();

  return useQuery(
    ["profileMonitoring", profileId],
    () => fetchProfileMonitoring(authHeader, Number(profileId)),
    {
      // the endpoint 403s without monitoring.view, which logs the user out
      enabled: !!profileId && hasPermission("monitoring.view"),
      keepPreviousData: true,
      retry: true,
      onError: (err: any) => {
        if (err?.request?.status === 500 || err?.request?.status === 503) {
          navigate(ROUTE.SERVER_ERROR);
        }
      },
    }
  );
};
